import { customerStatusApiClient } from "./clients";
import { CustomerStatusResponse } from "types/customerStatusApi.types";

export const getCustomerStatusList = () =>
  customerStatusApiClient.request<CustomerStatusResponse>({
    method: "GET",
    url: `/v1/customer-status`,
  });
